import { z } from 'zod';

export const WorkspaceSchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
  slug: z.string().min(1),
  created_at_ms: z.number().int().nonnegative(),
  archived_at_ms: z.number().int().nullable(),
  accepted_signing_key_ids: z.array(z.string()).default([]),
});

export const CreateWorkspaceSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  slug: z
    .string()
    .min(1, 'Slug is required')
    .regex(/^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/, 'Slug must be lowercase alphanumeric and dashes'),
});

export type ParsedWorkspace = z.infer<typeof WorkspaceSchema>;
export type ParsedCreateWorkspace = z.infer<typeof CreateWorkspaceSchema>;
